// extracted by mini-css-extract-plugin
export default {"anagraphicPageContainer":"anagraphic_anagraphicPageContainer__bI8jP","formWrapper":"anagraphic_formWrapper__8hoWW"};